export enum BOOKING_STATUS {
    Green = 0,
    Orange = 1,
    Red = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/model/booking-status.enum.ts